import { render, staticRenderFns } from "./sainte-lague.vue?vue&type=template&id=5c8ed0ae&"
import script from "./sainte-lague.vue?vue&type=script&lang=js&"
export * from "./sainte-lague.vue?vue&type=script&lang=js&"
import style0 from "./sainte-lague.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "sainte-lague.vue"
export default component.exports